import { computed, ref } from 'vue';
import { useGameStateStore } from '@/stores/gameState';
import { TEventTypes } from '@/constants';

export const useGameClock = () => {
  const store = useGameStateStore();

  const isSnapped = ref(false);
  const isTempStop = ref(false);
  const isFullStop = ref(true);

  const clockIsRunning = computed(() => store.gameState?.clockIsRunning);

  const quarter = computed(() => store.gameState?.quarter);
  const minutes = computed(() => store.gameState?.gameClock.minutes);
  const seconds = computed(() =>
    store.gameState?.gameClock.seconds < 10
      ? `0${store.gameState?.gameClock.seconds}`
      : store.gameState?.gameClock.seconds
  );

  const isTied = computed(() => store.gameState.awayTeamScore === store.gameState.homeTeamScore);
  const isOvertime = computed(() => store.gameState.quarter > 4);
  const quarterEnded = computed(() => minutes.value === 0 && seconds.value === (0 || '00'));

  function handleClockButtonClick(buttonType: string) {
    switch (buttonType) {
      case 'start':
        isTempStop.value = false;
        isFullStop.value = false;
        store.startClock();
        store.sendGameUpdate();
        break;
      case 'stop':
        if (isSnapped.value) {
          isTempStop.value = false;
          isFullStop.value = false;
          isSnapped.value = false;
        }
        break;
      case 'snap':
        if (!quarterEnded.value) {
          store.startClock();
          isSnapped.value = true;
          isFullStop.value = false;
          isTempStop.value = false;
        }
        store.fireGameEvent(TEventTypes.BALL_SNAP, true, false);
        break;
      case 'run':
        isSnapped.value = false;
        break;
      case 'full-stop':
        isFullStop.value = true;
        break;
      case 'temp-stop':
        isTempStop.value = true;
        break;
      case 'end-quarter':
        isFullStop.value = true;
        store.gameState.quarter += 1;
        if (store.gameState.quarter === 3) store.resetTimeouts();
        if (store.gameState.quarter < 5) {
          store.resetClock();
        } else {
          store.setOvertimeState();
        }
        store.sendGameUpdate();
        break;
      case 'end-game':
        store.gameState.gameStatusId = 4;
        store.sendGameUpdate();
        break;
      default:
        break;
    }
  }

  return {
    clockIsRunning,
    handleClockButtonClick,
    isOvertime,
    isSnapped,
    isTempStop,
    isFullStop,
    isTied,
    minutes,
    quarter,
    quarterEnded,
    seconds,
  };
};
